import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AgentProfile() {
  const { agent } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error("Passwords don't match"); return; }
    if (form.new_password.length < 6) { toast.error("Min 6 chars"); return; }
    setBusy(true);
    try {
      await api.post("/agents/change-password", { current_password: form.current_password, new_password: form.new_password });
      setForm({ current_password: "", new_password: "", confirm: "" });
      toast.success("Password changed");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Change failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div>
        <div className="overline">Account</div>
        <h1 className="font-display text-3xl font-extrabold mt-1">Profile</h1>
      </div>

      <div className="card-flat p-7 grid sm:grid-cols-2 gap-4 text-sm">
        <Row k="Agent code" v={<span className="font-mono font-bold text-saffron">{agent?.code}</span>}/>
        <Row k="Name" v={agent?.name}/>
        <Row k="Email" v={agent?.email}/>
        <Row k="Type" v={agent?.agent_type}/>
      </div>

      <form onSubmit={submit} className="card-flat p-7 space-y-4" data-testid="agent-pw-form">
        <h2 className="font-display text-xl font-bold">Change password</h2>
        <F label="Current password"><Input data-testid="ap-cur" type="password" value={form.current_password} onChange={e=>setForm({...form, current_password: e.target.value})} required/></F>
        <F label="New password"><Input data-testid="ap-new" type="password" value={form.new_password} onChange={e=>setForm({...form, new_password: e.target.value})} required/></F>
        <F label="Confirm new password"><Input data-testid="ap-conf" type="password" value={form.confirm} onChange={e=>setForm({...form, confirm: e.target.value})} required/></F>
        <Button data-testid="ap-save" type="submit" disabled={busy} className="btn-saffron rounded-full">
          {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin"/>} Update password
        </Button>
      </form>
    </div>
  );
}

function F({ label, children }) {
  return (<div className="space-y-1.5"><Label className="text-xs uppercase tracking-wider text-ink-muted">{label}</Label>{children}</div>);
}
function Row({ k, v }) {
  return (<div><div className="text-[10px] uppercase tracking-[0.18em] text-ink-muted">{k}</div><div className="font-display font-bold text-lg mt-1">{v}</div></div>);
}
